/* eslint-disable no-console,no-undef */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {StyledModal, PopupHeading, ButtonWrapper, CheckBoxWrap, CheckBoxCardContainer} from './style';
import {RecognitionCloseIcon} from '../../utils/icons'
import {CheckBoxContainer} from '../common/CommonDeptLoc/style'
import { RecognitionTickIcon } from '../../utils/icons';
import { ShowHrisToggleName } from "../../redux/constants/apiConstants";
import { toast } from "react-toastify";
import { fetchApi } from "../../utils/methods";
import { ImageUrl } from '../../utils/constants';

class CreateConsumer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSingleClick: false,
      selectFieldHris: [],
      isSelectAllActive: false,
      selectedIds: [1, 2, 3],
      companyId: props.companyInfo?.id,
    }
  }

  componentDidMount() {
    this.getHrisFieldName();
  }

  createConsumerPost = () =>{
    const {companyId, selectedIds} = this.state;
    const consumer = {
      company_id: companyId,
      field_types: selectedIds
    }
    const consumerCreate = {
      company_id: companyId
    }
    // this.setState({showSingleClick: true})
    this.props.updateConsumerField(consumer)
    this.props.createConsumer(consumerCreate)
    this.props.onCloseGeneratePopup()
  }

  getHrisFieldName = async () => {
    const companyId = this.state.companyId; 
    try {
      const response = await fetchApi(`${ShowHrisToggleName}/${companyId}`, "GET");
      if (response.message) {
        toast.error(res.message);
      }
      else {
        this.setState({ selectFieldHris: response?.data });
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  // Toggle individual checkbox and update selected IDs
  handleCheckboxChange = (id) => {
    this.setState(
      (prevState) => {
        const updatedCheckboxes = prevState.selectFieldHris?.map((checkbox) =>
          checkbox.id === id ? { ...checkbox, status: checkbox.status === 1 ? 0 : 1 } : checkbox
        );

        // Always include IDs 1, 2, 3 in selectedIds
        const updatedSelectedIds = [
          1, 2, 3, // Keep these IDs always selected
          ...updatedCheckboxes
            .filter((checkbox) => checkbox.status === 1 && ![1, 2, 3].includes(checkbox.id))
            .map((checkbox) => checkbox.id)
        ];

        return {
          selectFieldHris: updatedCheckboxes,
          selectedIds: updatedSelectedIds
        };
      },
      this.updateSelectAllState // Update "Select All" button state
    );
  };

  // Select All / Deselect All function (excluding IDs 1, 2, 3)
  toggleSelectAll = () => {
    const allSelected = this.state.selectFieldHris
      .filter((checkbox) => ![1, 2, 3].includes(checkbox.id))
      .every((checkbox) => checkbox.status === 1);

    this.setState(
      (prevState) => {
        const updatedCheckboxes = prevState.selectFieldHris?.map((checkbox) =>
          [1, 2, 3].includes(checkbox.id)
            ? checkbox // Keep IDs 1, 2, 3 unchanged
            : { ...checkbox, status: allSelected ? 0 : 1 } // Toggle others
        );

        const updatedSelectedIds = [
          1, 2, 3, // Always include these
          ...updatedCheckboxes
            .filter((checkbox) => checkbox.status === 1 && ![1, 2, 3].includes(checkbox.id))
            .map((checkbox) => checkbox.id)
        ];

        return {
          selectFieldHris: updatedCheckboxes,
          selectedIds: updatedSelectedIds
        };
      },
      this.updateSelectAllState // Update "Select All" button state
    );
  };

  // Function to check if all selectFieldHris (except 1,2,3) are selected
  updateSelectAllState = () => {
    const allSelected = this.state.selectFieldHris
      .filter((checkbox) => ![1, 2, 3].includes(checkbox.id))
      .every((checkbox) => checkbox.status === 1);

    this.setState({ isSelectAllActive: allSelected });
  };
  

  render() {
    const { show, onClose, showGeneratePopup, companyLogo } = this.props;
    const {showSingleClick, selectFieldHris, isSelectAllActive} = this.state;
    const disabled=false;
    return (
      !showGeneratePopup?<StyledModal show={show} width={"800px"} height="auto" onHide={() => onClose()} margin="16px 0">
        <div className='body'>
          <PopupHeading>
            <div className='title'>Create A New Consumer</div>
            <div className='close' onClick={() => onClose()}>
              {RecognitionCloseIcon('#F37A65')}
            </div>
            <div className='subtext'>Select the desired options to access details from integration tools.</div>
          </PopupHeading>
          <div className='border-line'></div>
          <CheckBoxWrap onClick={()=>this.toggleSelectAll()}>
            <CheckBoxContainer selected={ isSelectAllActive }>
              <div className="archive-action">{isSelectAllActive? RecognitionTickIcon():null}</div>
            </CheckBoxContainer>
            <div className='text'>Select all fields</div>
          </CheckBoxWrap>
          <div className='border-line'></div>
          <CheckBoxCardContainer>
            {selectFieldHris?.length>0 && selectFieldHris?.map((data,index)=><CheckBoxWrap key={index} width="192px" onClick={()=>this.handleCheckboxChange(data.id)}>
              <CheckBoxContainer selected={data.status} disabled={data?.id===1||data?.id===2||data?.id===3}>
                <div className="archive-action">{data?.id===1||data?.id===2||data?.id===3?RecognitionTickIcon("#BDBDBD"):  data.status? RecognitionTickIcon(data?.id===1||data?.id===2||data?.id===3?"#BDBDBD":"#F37A65"):null}</div>
              </CheckBoxContainer>
              <div className='text'>{data?.field_name}</div>
            </CheckBoxWrap>)}
          </CheckBoxCardContainer>
          <ButtonWrapper disable={disabled} margin={"20px 0 0 0"}>
            <div className='cancel' onClick={() => onClose()}>Cancel</div>
            <div className='create' onClick={showSingleClick?null: disabled?null:() => this.createConsumerPost()}>Select</div>
          </ButtonWrapper>
        </div>
      </StyledModal>:
        <StyledModal show={showGeneratePopup} width={"400px"} height="auto" margin="16px 0" paddingV="0px">
          <div className='body'>
            <div className='generate-popup'>
              <div className='icon'>
                <img src={ImageUrl+"/"+companyLogo?.header_logo}/>
              </div>
              <div className='text'>Generating...</div>
            </div>
          </div>
        </StyledModal>
    );
  }
}

CreateConsumer.propTypes = {
  show:PropTypes.bool,
  hidePopup: PropTypes.func,
  onClose: PropTypes.func,
  t: PropTypes.func,
  companyInfo: PropTypes.object,
  companyLogo: PropTypes.object,
  createConsumer: PropTypes.func,
  showGeneratePopup: PropTypes.bool,
  onCloseGeneratePopup: PropTypes.bool,
  updateConsumerField: PropTypes.func
};

export default CreateConsumer;